<app-menu></app-menu>

<section class="controlsocial-page">
  <div class="page-guide">CONTROLPS / CONTROLSOCIAL</div>

  <header class="hero-card">
    <div>
      <h1>ControlSocial</h1>
      <p>Integração com WhatsApp Business para centralizar atendimento, histórico e operação por tenant.</p>
      <div class="hero-pills">
        <span>Canal: {{ activeChannelLabel }}</span>
        <span>Conversas: {{ totalConversations }}</span>
        <span>Em aberto: {{ openConversations }}</span>
        <span>Não lidas: {{ unreadConversations }}</span>
      </div>
    </div>

    <div class="hero-actions">
      <button type="button" class="btn primary" (click)="setActiveTab('channel')">Canal WhatsApp</button>
      <button type="button" class="btn ghost" (click)="setActiveTab('inbox')">Inbox social</button>
    </div>
  </header>

  <div class="page-feedback" *ngIf="feedback" [class.error]="feedbackType === 'error'" [class.success]="feedbackType === 'success'">
    <span>{{ feedback }}</span>
    <button type="button" (click)="clearFeedback()">Fechar</button>
  </div>

  <div class="tab-toolbar">
    <div class="tab-bar">
      <button type="button" [class.active]="activeTab === 'channel'" (click)="setActiveTab('channel')">Configuração do canal</button>
      <button type="button" [class.active]="activeTab === 'inbox'" (click)="setActiveTab('inbox')">Inbox de conversas</button>
    </div>
  </div>

  <ng-container *ngIf="activeTab === 'channel'">
    <article class="card">
      <div class="section-head">
        <h2>Canal Meta WhatsApp</h2>
        <div class="section-head-actions">
          <small *ngIf="channel">Canal #{{ channel.id }} · {{ channel.status }}</small>
          <button type="button" class="ghost" *ngIf="hasChannels" (click)="toggleChannelForm()">
            {{ showChannelForm ? 'Ocultar cadastro' : 'Abrir cadastro' }}
          </button>
        </div>
      </div>

      <p *ngIf="loadingChannel">Carregando configuração do canal...</p>

      <form *ngIf="!loadingChannel && showChannelForm" class="channel-form" (ngSubmit)="saveChannel()">
        <p class="edit-hint" *ngIf="editingChannelId">Editando canal #{{ editingChannelId }}</p>

        <div class="inline-grid">
          <label>
            Nome do canal
            <input type="text" [(ngModel)]="channelForm.channel_name" name="channel_name" required>
          </label>
          <label>
            Status
            <select [(ngModel)]="channelForm.status" name="channel_status">
              <option value="ACTIVE">Ativo</option>
              <option value="INACTIVE">Inativo</option>
            </select>
          </label>
        </div>

        <div class="inline-grid">
          <label>
            Phone Number ID (Meta)
            <input type="text" [(ngModel)]="channelForm.phone_number_id" name="phone_number_id" required>
          </label>
          <label>
            WABA ID
            <input type="text" [(ngModel)]="channelForm.waba_id" name="waba_id" required>
          </label>
          <label>
            Número do WhatsApp
            <input type="text" [(ngModel)]="channelForm.business_phone_number" name="business_phone_number" placeholder="+55...">
          </label>
        </div>

        <div class="inline-grid">
          <label>
            Access Token (Meta)
            <input type="password" [(ngModel)]="channelForm.access_token" name="access_token" placeholder="Cole o token da Meta">
            <small *ngIf="channel?.has_access_token">Token já configurado. Preencha apenas se quiser trocar.</small>
          </label>
          <label>
            Webhook Verify Token
            <input type="password" [(ngModel)]="channelForm.webhook_verify_token" name="webhook_verify_token" placeholder="Token de validação do webhook">
            <small *ngIf="channel?.has_webhook_verify_token">Token já configurado. Preencha apenas se quiser trocar.</small>
          </label>
          <label>
            App Secret (opcional)
            <input type="password" [(ngModel)]="channelForm.app_secret" name="app_secret" placeholder="Segredo do app Meta">
            <small *ngIf="channel?.has_app_secret">Segredo já configurado. Preencha apenas se quiser trocar.</small>
          </label>
        </div>

        <label>
          URL do webhook
          <input type="text" [(ngModel)]="channelForm.webhook_url" name="webhook_url">
        </label>

        <div class="actions">
          <button type="submit" [disabled]="savingChannel">
            {{ savingChannel ? 'Salvando...' : 'Salvar configuração' }}
          </button>
          <button type="button" class="ghost" (click)="loadChannel()" [disabled]="savingChannel">Recarregar</button>
        </div>
      </form>

      <p class="empty collapsed-hint" *ngIf="!loadingChannel && !showChannelForm && hasChannels">
        Cadastro recolhido. Use o botão "Abrir cadastro" para editar o canal.
      </p>
    </article>

    <article class="card" *ngIf="hasChannels">
      <div class="section-head">
        <h2>Canais cadastrados</h2>
      </div>

      <div class="channel-list">
        <div class="channel-row channel-row-head">
          <span>Canal</span>
          <span>Phone Number ID</span>
          <span>Número</span>
          <span>Status</span>
          <span>Ações</span>
        </div>

        <div class="channel-row" *ngFor="let item of channels">
          <span>{{ item.channel_name || 'WhatsApp' }}</span>
          <span>{{ item.phone_number_id || '-' }}</span>
          <span>{{ item.business_phone_number || '-' }}</span>
          <span>
            <strong [class.status-active]="item.status === 'ACTIVE'" [class.status-inactive]="item.status !== 'ACTIVE'">
              {{ item.status || 'ACTIVE' }}
            </strong>
          </span>
          <span>
            <button type="button" class="ghost" (click)="editChannel(item)">Editar</button>
          </span>
        </div>
      </div>
    </article>
  </ng-container>

  <ng-container *ngIf="activeTab === 'inbox'">
    <section class="workspace-grid">
      <article class="card">
        <div class="section-head">
          <h2>Conversas</h2>
          <button type="button" (click)="loadConversations()">Atualizar</button>
        </div>

        <form class="filter-row" (ngSubmit)="applyConversationFilters()">
          <label>
            Buscar contato
            <input type="text" [(ngModel)]="search" name="search" placeholder="Nome ou telefone">
          </label>
          <label>
            Status
            <select [(ngModel)]="statusFilter" name="status_filter">
              <option value="">Todos</option>
              <option value="OPEN">Abertas</option>
              <option value="CLOSED">Fechadas</option>
              <option value="ARCHIVED">Arquivadas</option>
            </select>
          </label>
          <div class="actions filter-actions">
            <button type="submit">Aplicar filtros</button>
            <button type="button" class="ghost" (click)="clearConversationFilters()">Limpar</button>
          </div>
        </form>

        <p *ngIf="loadingConversations">Carregando conversas...</p>

        <div class="conversation-list" *ngIf="!loadingConversations">
          <button
            type="button"
            class="conversation-item"
            *ngFor="let conversation of conversations"
            [class.active]="selectedConversation?.id === conversation.id"
            (click)="selectConversation(conversation)"
          >
            <div class="row">
              <strong>{{ conversation.profile_name || 'Sem nome' }}</strong>
              <span>{{ formatDate(conversation.last_message_at) }}</span>
            </div>
            <small>{{ conversation.phone_e164 || conversation.whatsapp_user_id }}</small>
            <p>{{ messagePreview(conversation) }}</p>
            <span class="badge" [class.closed]="conversation.status !== 'OPEN'">
              {{ conversation.status || 'OPEN' }}
            </span>
            <span class="unread" *ngIf="conversation.unread_count">{{ conversation.unread_count }}</span>
          </button>
          <p class="empty" *ngIf="!conversations.length">Nenhuma conversa encontrada.</p>
        </div>
      </article>

      <article class="card">
        <div class="section-head">
          <h2>Mensagens</h2>
          <small *ngIf="selectedConversation">
            {{ selectedConversation.profile_name || 'Contato' }} · {{ selectedConversation.phone_e164 || selectedConversation.whatsapp_user_id }}
          </small>
        </div>

        <div class="messages-panel" *ngIf="selectedConversation; else emptyConversationState">
          <p *ngIf="loadingMessages">Carregando mensagens...</p>

          <div class="messages-list" *ngIf="!loadingMessages">
            <article class="message-item" *ngFor="let message of messages" [class.outgoing]="isOutgoing(message)">
              <header>
                <strong>{{ messageAuthorLabel(message) }}</strong>
                <span>{{ formatDate(message.created_at || message.received_at || message.sent_at) }}</span>
              </header>
              <p class="message-text">{{ message.message_text || '-' }}</p>
              <p class="message-error" *ngIf="messageFailureReason(message)">
                Motivo da falha: {{ messageFailureReason(message) }}
              </p>
              <div class="attachment-list" *ngIf="message.attachments?.length">
                <small>Anexos recebidos:</small>
                <span *ngFor="let attachment of message.attachments">
                  {{ attachment.file_name || attachment.meta_media_id || 'arquivo' }}
                </span>
              </div>
              <footer>
                <span class="status">{{ message.status }}</span>
                <span class="type">{{ message.message_type }}</span>
              </footer>
            </article>
            <p class="empty" *ngIf="!messages.length">Sem mensagens para esta conversa.</p>
          </div>
        </div>

        <ng-template #emptyConversationState>
          <p class="empty">Selecione uma conversa para carregar mensagens.</p>
        </ng-template>

        <form class="composer" (ngSubmit)="sendTextMessage()">
          <label>
            Número destino
            <input type="text" [(ngModel)]="outboundTo" name="outbound_to" placeholder="+55..." required>
          </label>
          <label>
            Mensagem
            <textarea [(ngModel)]="outboundText" name="outbound_text" rows="3" placeholder="Digite a mensagem" required></textarea>
          </label>
          <div class="actions">
            <button type="submit" [disabled]="sendingMessage">
              {{ sendingMessage ? 'Enviando...' : 'Enviar mensagem' }}
            </button>
          </div>
        </form>
      </article>
    </section>
  </ng-container>
</section>
